// extracted by mini-css-extract-plugin
export default {"card":"CategoryCard_card__soNtr","icon":"CategoryCard_icon__t7ipc","name":"CategoryCard_name__bBaOU"};